import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

// reactstrap components
import {
  Button,
  Collapse,
  NavLink,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
  UncontrolledTooltip,
} from "reactstrap";

import * as actions from "../../store/actions/index";

const DarkNavbar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [navbarColor, setNavbarColor] = useState(
    (document.documentElement.scrollTop > 499 || document.body.scrollTop) > 499
      ? ""
      : " black"
  );
  const [buyButtonColor, setBuyButtonColor] = useState(
    (document.documentElement.scrollTop > 499 || document.body.scrollTop) > 499
      ? "black"
      : "black"
  );
  useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 499 ||
        document.body.scrollTop > 499
      ) {
        setNavbarColor("");
        setBuyButtonColor("info");
      } else if (
        document.documentElement.scrollTop < 500 ||
        document.body.scrollTop < 500
      ) {
        setNavbarColor(" black");
        setBuyButtonColor("neutral");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top" + navbarColor} color="white" expand="lg">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand to="/" tag={Link} id="navbar-brand">
              All My Sports SA
            </NavbarBrand>
            <UncontrolledTooltip target="navbar-brand">
              Main Site
            </UncontrolledTooltip>
            <button
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              className="navbar-toggler"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse isOpen={collapseOpen} navbar>
            <Nav className="ml-auto" id="ceva" navbar>
              {!props.authenticated ? (
                <NavItem>
                  <NavLink to="/Login" tag={Link}>
                    <i className="now-ui-icons users_circle-08"></i>
                    <p>Login</p>
                  </NavLink>
                </NavItem>
              ) : null}

              {props.authenticated ? (
                <NavItem>
                  <NavLink to="/Profile" tag={Link}>
                    <i className="now-ui-icons users_single-02"></i>
                    <p>Profile</p>
                  </NavLink>
                </NavItem>
              ) : null}

              {props.authenticated ? (
                <NavItem>
                  <NavLink to="/Logout" tag={Link}>
                    <i className="now-ui-icons media-1_button-power"></i>
                    <p>Logout</p>
                  </NavLink>
                </NavItem>
              ) : null}

              <NavItem>
                <NavLink to="/Help" tag={Link}>
                  <i className="now-ui-icons travel_info"></i>
                  <p>Help</p>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  // href="fb://page/575567359182689"
                  href="https://www.facebook.com/AllmysportsSA/"
                  target="_blank"
                  id="facebook-tooltip"
                >
                  <i className="fab fa-facebook-square"></i>
                  <p className="d-lg-none d-xl-none">Facebook</p>
                </NavLink>
                <UncontrolledTooltip target="#facebook-tooltip">
                  Like us on Facebook
                </UncontrolledTooltip>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://www.instagram.com/allmysportssa?ref=allmysportssa"
                  target="_blank"
                  id="instagram-tooltip"
                >
                  <i className="fab fa-instagram"></i>
                  <p className="d-lg-none d-xl-none">Instagram</p>
                </NavLink>
                <UncontrolledTooltip target="#instagram-tooltip">
                  Follow us on Instagram
                </UncontrolledTooltip>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
    error: state.authentication.error,
    authenticated: state.authentication.authenticated,
    // authRedirectPath: state.authentication.authRedirectPath,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogin: (email, password) => dispatch(actions.login(email, password)),
    // onAuthCheckState: () => dispatch(actions.authCheckState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DarkNavbar);
